import React from 'react'

export const Header = () => {
  return (
    <h2 className='htwo'>
      Money Manager
    </h2>
  )
}